// Port and airport codes for metro trucking sheets, shared by the admin Metro Tariff page and
// Elariom's no-agent converter (src/server/rateAgent/converters.js).

// Known AU/NZ port names -> UN/LOCODE (Phase I scope). Editable in the UI if a
// sheet uses a port not listed here.
export const PORT_CODE_MAP = {
    BRISBANE: 'AUBNE', SYDNEY: 'AUSYD', MELBOURNE: 'AUMEL', FREMANTLE: 'AUFRE',
    PERTH: 'AUFRE', ADELAIDE: 'AUADL', AUCKLAND: 'NZAKL', TAURANGA: 'NZTRG',
    WELLINGTON: 'NZWLG', LYTTELTON: 'NZLYT', CHRISTCHURCH: 'NZLYT',
};

// An air trucking sheet writes the same city name in its PORT column, but means the airport —
// "Melbourne" is Tullamarine, not the Port of Melbourne, and they are 20km and two very different
// drayage runs apart. Airports are identified by their 3-letter IATA code, so an air sheet needs
// its own lookup: Melbourne alone answers to three airports (Avalon, Moorabbin, Tullamarine), so
// the city is spelt out to the one the freight actually flies through rather than guessed at.
export const AIRPORT_CODE_MAP = {
    MELBOURNE: 'MEL', SYDNEY: 'SYD', BRISBANE: 'BNE', PERTH: 'PER', ADELAIDE: 'ADL',
    AUCKLAND: 'AKL', CHRISTCHURCH: 'CHC', WELLINGTON: 'WLG', TAURANGA: 'TRG',
};

// Country for an airport cannot be sliced off the front of its code the way it can off a
// UN/LOCODE: MEL would read as Montenegro. These are the countries of the airports above.
export const AIRPORT_COUNTRY = {
    MEL: 'AU', SYD: 'AU', BNE: 'AU', PER: 'AU', ADL: 'AU',
    AKL: 'NZ', CHC: 'NZ', WLG: 'NZ', TRG: 'NZ',
};

// A sheet of air trucking says so in its own header block ("SERVICE: AIR TRUCKING MELBOURNE,
// AUSTRALIA") and again in every row's MODE. Either is enough to know the PORT column names an
// airport, so the operator is not left to notice it themselves.
export function isAirSheet({ meta, modes }) {
    if (/\bAIR\b/i.test(meta?.service || '')) return true;
    return Array.isArray(modes) && modes.length > 0 && modes.every(m => m === 'AIR');
}
